<template>
  <div class="personal">
    <!-- 显示 -->
    <div class="main_top">
      <el-card class="m_t_left">
        <h3>
          <i class="el-icon-s-data"></i>业务统计
        </h3>
        <div class="m_box">
          <div class="m-img">
            <img src="../assets/a.png" alt />
          </div>
          <div class="m_box_cent">
            <h4>全部</h4>
            <p style="color:#2da1f9">{{this.staticsData.count1}}</p>
          </div>
        </div>
        <div class="m_box">
          <div class="m-img">
            <img src="../assets/b.png" alt />
          </div>
          <div class="m_box_cent">
            <h4>未入仓</h4>
            <p style="color:#67ca29">{{this.staticsData.count2}}</p>
          </div>
        </div>
        <div class="m_box">
          <div class="m-img">
            <img src="../assets/c.png" alt />
          </div>
          <div class="m_box_cent">
            <h4>未发货</h4>
            <p style="color:#fda005">{{this.staticsData.count3}}</p>
          </div>
        </div>
        <div class="m_box">
          <div class="m-img">
            <img src="../assets/d.png" alt />
          </div>
          <div class="m_box_cent">
            <h4>已发货</h4>
            <p style="color:#3ec6c4">{{this.staticsData.count4}}</p>
          </div>
        </div>
        <div class="m_box">
          <div class="m-img">
            <img src="../assets/e.png" alt />
          </div>
          <div class="m_box_cent">
            <h4>已清关</h4>
            <p style="color:#e07070">{{this.staticsData.count5}}</p>
          </div>
        </div>
        <div class="m_box">
          <div class="m-img">
            <img src="../assets/f.png" alt />
          </div>
          <div class="m_box_cent">
            <h4>已签收</h4>
            <p style="color:#4977fc">{{this.staticsData.count6}}</p>
          </div>
        </div>
      </el-card>
      <el-card class="m_t_center">
        <h3><i class="el-icon-user"/>账号信息</h3>
        <div class="m_title">
          <img src="../assets/person.png" />
          <h2>{{this.userData.username}}</h2>
        </div>
        <div>
          <el-button size="mini" @click="toAccount">修改资料</el-button>
          <el-button size="mini" @click="toPassword">修改密码</el-button>
          <el-button size="mini" @click="autheDialog">实名认证</el-button>
          <el-button size="mini" @click="wxLoginDialog" v-if="this.userData.nickname!=''&&this.userData.nickname!=null&&this.userData.nickname!=undefined">微信解绑</el-button>
          <el-button size="mini" @click="wxLoginDialog" v-else>微信绑定</el-button>
        </div>
        <ul class="m_btn">
          <li>
            <b>用户编号:</b>
            <span>{{this.userData.userCode}}</span>
          </li>
          <li>
            <b>微信昵称:</b>
            <span v-if="this.userData.nickname!=''&&this.userData.nickname!=null&&this.userData.nickname!=undefined" style="color:#409EFF;">{{this.userData.nickname}}</span>
            <span v-else style="color:red;">未绑定微信</span>
          </li>
          <li>
            <b>账号状态:</b>
            <span v-if="this.userData.statusTxt == '正常'">{{this.userData.statusTxt}}</span>
            <span v-else style="color:red;">{{this.userData.statusTxt}}</span>
          </li>
          <li>
            <b>会员级别:</b>
            <span>vip</span>
          </li>
          <li>
            <b>业务员:</b>
            <span>{{this.userData.sellerName}}</span>
          </li>
          <li>
            <b>实名认证:</b>
            <span v-if="this.userData.userAuthe === '1'" style="color:#409EFF;">已认证</span>
            <span v-else style="color:red;">未认证</span>
          </li>
        </ul>
      </el-card>
      <el-card class="m_t_right" style="margin-right:0">
        <h3><i class="el-icon-money"/>用户余额</h3>
        <ul class="m-btn">
          <li>
            <b>信用额度:</b>
            <span>{{this.balanceData.credit}} 元</span>
          </li>
          <li>
            <b>剩余额度:</b>
            <span v-if="this.balanceData.remainingCredit>=0">{{this.balanceData.remainingCredit}}元</span>
            <span v-else style="color:red;">{{this.balanceData.remainingCredit}}元</span>
          </li>
          <li>
            <b>总消费:</b>
            <span>{{this.balanceData.totalConsumption }} 元</span>
          </li>
          <li>
            <b>待付款:</b>
            <span v-if="balanceData.obligations>='0'" style="color:#F56C6C">{{this.balanceData.obligations }} 元</span>
            <span v-else>{{this.balanceData.obligations}}元</span>
          </li>
        </ul>
      </el-card>
    </div>
    <div class="main_btn">
      <el-card class="m_b_left">
        <h3><i class="el-icon-warning-outline"/>问题件</h3>
        <el-table
          :data="abnormalData"
          class="table"
          :header-cell-style="{background:'#eef1f6',color:'#606266'}"
          border
          style="width:100%;margin-top:20px;"
          max-height="400"
        >
          <el-table-column fixed label="运单号">
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="toOrderdeta(scope.row.orderNo)"
              >{{ scope.row.clientNo }}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="问题件" prop="problemRemark"></el-table-column>
          <el-table-column label="订单日期">
            <template slot-scope="scope">
              <span style="margin-left: 10px">
                {{
                scope.row.createTime | dateformat('YYYY-MM-DD')
                }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-card class="m_b_center">
        <h3><i class="el-icon-download"/>文件下载</h3>
        <el-table
          :data="orderFileData"
          class="table"
          :header-cell-style="{background:'#eef1f6',color:'#606266'}"
          border
          style="width:100%;margin-top:20px;"
          max-height="400"
        >
          <el-table-column label="运单号" prop="clientNo"></el-table-column>
          <el-table-column label="文件类型">
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                style="margin-left:10px"
                @click="file(scope.row)"
              >{{ scope.row.typeTxt }}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="订单日期">
            <template slot-scope="scope">
              <span style="margin-left: 10px">
                {{
                scope.row.createTime | dateformat('YYYY-MM-DD')
                }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-card class="m_b_right" style="margin-right:0">
        <h3><i class="el-icon-bell"/>物流通知</h3>
        <el-table
          :data="logstatusData"
          class="table"
          :header-cell-style="{background:'#eef1f6',color:'#606266'}"
          border
          style="width:100%;margin-top:20px;"
          max-height="400"
        >
          <el-table-column label="运单号">
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="toOrderdeta(scope.row.orderNo)"
              >{{ scope.row.clientNo }}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="最新物流" prop="status"></el-table-column>
          <el-table-column label="发生时间">
            <template slot-scope="scope">
              <span style="margin-left: 10px">
                {{
                scope.row.createTime | dateformat('YYYY-MM-DD')
                }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-dialog title="实名认证"
        :visible.sync="autheDialogVisible"
        :close-on-click-modal="false"
        style="text-align:center;">
        <el-upload style="text-align:left"
        class="upload-demo"
        :action="UploadUrl()+'/file/upload'"
        list-type="picture-card"
        :file-list="fileList"
        :on-preview="handlePictureCardPreview"
        :on-success="businessSuccess"
        :before-upload="beforeUpload"
        :limit="5"
        name="upload"
        ref="uploadDeliveryImgRef">
        <i class="el-icon-plus"></i>
      </el-upload>
      <el-button @click="waterSingle">提交</el-button>
      </el-dialog>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
      <el-dialog
        :visible.sync="msgDialogVisible"
        :close-on-click-modal="false"
        width="342px"
        :modal-append-to-body = "false">
        <Wxlogin
          id="wxLoginForm"
          :appid="appid"
          :scope="scope"
          :redirect_uri="redirect_uri"
        ></Wxlogin>
      </el-dialog>
    </div>
  </div>
</template>

<script>
//引入api
import httpApi from "../http/api";

import Wxlogin from "vue-wxlogin"
export default {
  name: "Personal",
  components: {
    Wxlogin // 声明引用组件
  },
  data() {
    return {
      orderData: [], //问题件
      balanceData: {}, //用户余额
      staticsData: {}, //业务统计
      abnormalData: [], //问题件
      orderFileData: [], //下载文件
      logstatusData: [], //用户通知
      userData: {}, //用户信息
      autheDialogVisible: false,
      dialogVisible: false,
      dialogImageUrl: '',
      deliveryImg: [],
      fileList: [],
      appid: "", // 应用唯一标识，在微信开放平台提交应用审核通过后获得
      scope: "snsapi_login", // 应用授权作用域，网页应用目前仅填写snsapi_login即可
      redirect_uri: "", // 重定向地址 （回调地址）
      msgDialogVisible: false,
      code: ""
    };
  },
  methods: {
    //点击订单号跳往详情
    toOrderdeta(orderNo) {
      this.$router.push("/orderdetails/" + orderNo);
    },
    //文件下载
    file(row) {
      window.open(row.url);
    },
    //修改账号
    toAccount() {
      this.$router.push("/account");
    },
    toPassword() {
      this.$router.push("/changepass");
    },
    //用户余额
    balanceM() {
      let that = this;
      httpApi.balanceM().then(res => {
        if (res.data.code == "ok") {
          that.balanceData = res.data.data;
          if (that.balanceData.credit === null || that.balanceData.credit === ""){
            that.balanceData.credit = 0;
            that.balanceData.remainingCredit = 0;
          }else{
            that.balanceData.remainingCredit = (that.balanceData.credit*1000 - that.balanceData.obligations*1000)/1000;
            if (that.balanceData.remainingCredit < 0){
              that.userData.statusTxt = "扣货中";
            }
          }
        } else {
          that.$message.error(res.data.message);
        }
      });
    },
    //业务统计
    staticsM() {
      let that = this;
      httpApi.staticsM().then(res => {
        if (res.data.code == "ok") {
          that.staticsData = res.data.data;
        } else {
          that.$message.error(res.data.message);
        }
      });
    },
    //问题件
    abnormal() {
      let that = this;
      httpApi.abnormal().then(res => {
        if (res.data.code == "ok") {
          that.abnormalData = res.data.data;
        } else {
          that.$message.error(res.data.message);
        }
      });
    },
    //文件下载
    orderFile() {
      let that = this;
      httpApi.orderFile().then(res => {
        if (res.data.code == "ok") {
          that.orderFileData = res.data.data.rows;
        } else {
          that.$message.error(res.data.message);
        }
      });
    },
    //实名认证弹框
    autheDialog(){
      this.autheDialogVisible = true;
    },
    //用户通知
    logstatus() {
      let that = this;
      httpApi.logstatus().then(res => {
        if (res.data.code == "ok") {
          that.logstatusData = res.data.data;
        } else {
          that.$message.error(res.data.message);
        }
      });
    },
    //查询客户信息
    getUser() {
      let that = this;
      httpApi.getUser().then(res => {
        if (res.data.code == "ok") {
          that.userData = res.data.data;
          that.userData.findUserFileResponseList.forEach(v =>{
            that.fileList.push({name:v.name,url:v.url})
          })
          //运行微信绑定解绑，重定向回来无法获取到用户的微信昵称，就无法判断是绑定还是解绑，会一直进行绑定程序
          this.bindingWeixin();
        } else {
          that.$message.error(res.data.message);
        }
      });
    },
    UploadUrl(){
      return this.mApi
    },
    handlePictureCardPreview(file){
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    businessSuccess(file, fileList){
      let data = fileList.response.data;
      this.deliveryImg.push(data.url);
    },
    beforeUpload(file){
        let isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/bmp';
        let isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
            this.$message.error('只能上传jpeg、jpg、png、bmp格式的图片');
        }
        if (!isLt2M) {
            this.$message.error('上传图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
    },
    waterSingle(){
      let that = this;
      httpApi
        .userAuthe({
          params:{
            username: that.userData.id,
            imgUrl: that.deliveryImg.join()
          }
        })
        .then(res => {
          that.$router.go(0);
          that.$message.success("认证成功!");
        })
    },
    initWeixin(){
      let that = this;
      httpApi
        .listParams({
          params: {
            type: "sys_weixin",
            enable: "1",
          },
        })
        .then((res) => {
          if (res.data.code == "ok") {
            that.redirect_uri = encodeURI("http://"+res.data.data[0].encodeUrl+"/personal");
            that.appid = res.data.data[0].appid;
          }
        });
    },
    wxLoginDialog() {
      this.msgDialogVisible = true;
    },
    bindingWeixin() {
      if(this.code!=null&&this.code!=undefined&&this.code!=""){debugger
        if(this.userData.nickname!=''&&this.userData.nickname!=null&&this.userData.nickname!=undefined){
          httpApi
            .unbindWeixin({
              params:{
                code: this.code
              }
            })
            .then(res => {
              if (res.data.code == "ok") {
                this.$message.success("解绑成功!");
                this.$router.push("/login")
              } else {
                this.$message.error(res.data.message);
              }
            });
        }else{
          httpApi
            .bindingWeixin({
              params:{
                code: this.code
              }
            })
            .then(res => {
              if (res.data.code == "ok") {
                this.$message.success("绑定成功!");
                this.$router.push("/login")
              } else {
                this.$message.error(res.data.message);
              }
            });
        }
      }
    },
  },
  created() {
    this.code = this.$route.query.code;
    this.initWeixin();
    this.getUser();
    this.staticsM();
    this.abnormal();
    this.orderFile();
    this.logstatus();
    this.balanceM();
  }
};
</script>

<style lang="less" scoped>
.main_top{
  min-width: 1000px;
  width:100%;
  height: 235px;  
  display: flex;
}
.main_btn {
  min-width: 1000px;
  width:100%;
  min-height:60vh;
  height: 100vh;
  display: flex;
}
.main_top,
.main_btn {
  // max-width: 1200px;
  min-width: 1000px;
  width:100%;
  height: 235px;
  
  display: flex;
  // justify-content: space-between;
  .m_t_left,
  .m_t_center,
  .m_t_right,
  .m_b_left,
  .m_b_center,
  .m_b_right {
    // padding: 15px;
    margin-right: 24px;
    h3 {
      text-align: left;
      font-size: 14px;
      margin-top: 15px;
      // color:#0073c0;
      // text-decoration: underline;
      i {
        font-size: 14px;
        font-weight: bold;
        margin-right: 4px;
      }
    }
  }
}
.main_top .el-card {
  margin-top: 0;
}
.main_top {
  .m_t_left {
    width: 450px;
    .m_box {
      margin-top: 20px;
      float: left;
      width: 33%;
      height: 40%;
      margin-bottom: 15px;
      position: relative;
      .m-img {
        width: 50%;
        float: left;
        img {
          display: inline-block;
          width: 50px;
          height: 50px;
        }
      }
      .m_box_cent {
        width: 50%;
        float: left;
        h4 {
          margin-top: 5px;
        }
        p {
          font-size: 18px;
          margin-top: 5px;
        }
      }
    }
  }

  .m_t_center {
    width: 450px;
    .m_title {
      margin-top: 10px;
      height: 60px;
      line-height: 50px;
      img {
        float: left;
        width: 50px;
        height: 50px;
      }
      h2 {
        float: left;
      }
      button {
        margin-left: 20px;
      }
    }
    .m_btn {
      width: 100%;
      height: 100px;
      margin-top: 10px;
      li {
        list-style: none;
        width: 45%;
        float: left;
        height: 30px;
        line-height: 30px;
        text-align: left;
        b {
          display: inline-block;
          width: 60px;
        }
      }
    }
  }
  .m_t_right {
    width: 450px;
    .m-btn {
      margin-top: 25px;
      li {
        list-style: none;
        text-align: left;
        b {
          width: 60px;
          display: inline-block;
          line-height: 30px;
          text-align: right;
        }
        span {
          font-size: 18px;
          display: inline-block;
          line-height: 30px;
          margin-left: 5px;
        }
      }
    }
  }
}
.main_btn {
  .m_b_left {
    width: 450px;
    .table {
      /deep/th > .cell {
        text-align: center !important;
        font-size: 12px;
      }
    }
  }
  .m_b_center {
    width: 450px;
    .table {
      /deep/th > .cell {
        text-align: center !important;
        font-size: 12px;
      }
    }
  }
  .m_b_right {
    width: 450px;
    .table {
      /deep/th > .cell {
        text-align: center !important;
        font-size: 12px;
      }
    }
  }
}
/deep/.el-table .cell {
  text-align: center;
}
</style>